var _a;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './editActionSchemaModal.view.html';
import angular from 'angular';
import { getDefaultActionSchema, validateJsonActionSchema } from '../../../../aiAgent/utils/AgentUtils';
import { BuilderFeatures } from '../../../../BuilderFeatures';
let EditActionSchemaModalComponent = class EditActionSchemaModalComponent {
    static $inject = ['$timeout'];
    constructor($timeout) {
        this.$timeout = $timeout;
        //#endregion
        //#region Properties
        this.initialSchema = '';
        this.initialStringifySchema = '';
        this.workingSchema = '';
        this.isInvalidSchema = false;
        this.hasChanges = false;
        this.propertySchemaDebounceDelay = 300;
        this.propertySchemaTimeout = null;
        this.isSchemaEditorEnabled = false;
        // onTabChange = (_event: CustomEvent) => {}
        // onPropertySchemaChange = ($schema: any) => {}
        // onDidCreateEditor = (_$event: any) => {}
        this.onChangeSchema = ($schema) => {
            this.validateSchema($schema);
            this.workingSchema = $schema;
            this.hasChanges = $schema !== this.initialStringifySchema;
        };
        this.onPropertySchemaChange = ($schema) => {
            if (this.propertySchemaTimeout) {
                this.$timeout.cancel(this.propertySchemaTimeout);
            }
            this.propertySchemaTimeout = this.$timeout(() => {
                this.onChangeSchema(JSON.stringify($schema, null, '\t'));
            }, this.propertySchemaDebounceDelay);
        };
        this.onTabChange = () => {
            // Delay is needed to ensure the editor and schema state are updated after tab change animation/render completes.
            this.$timeout(() => {
                try {
                    this.initialSchema = this.workingSchema;
                    this.workingPropertySchema = JSON.parse(this.workingSchema);
                    if (this.editor) {
                        this.editor.layout();
                    }
                }
                catch (error) {
                    console.error('Error parsing schema on tab change:', error);
                }
            }, 200);
        };
        this.onDidCreateEditor = ($event) => {
            this.$timeout(() => {
                if ($event?.editor) {
                    this.editor = $event.editor;
                }
            });
        };
        //#region Helper methods
        this.validateSchema = (schema) => {
            this.isInvalidSchema = !validateJsonActionSchema(schema);
        };
    }
    //#region Lifecycle Hooks
    $onInit() {
        this.propertySchema = angular.copy(this.action.$inputSchema);
        this.workingPropertySchema = angular.copy(this.propertySchema);
        this.initialStringifySchema = this.getSchemaString(this.propertySchema);
        this.initialSchema = this.initialStringifySchema;
        this.workingSchema = this.initialStringifySchema;
        this.checkFeatures();
    }
    $onChanges(changes) {
        if (changes.action && changes.action.currentValue) {
            this.propertySchema = angular.copy(this.action.$inputSchema);
            this.workingPropertySchema = angular.copy(this.propertySchema);
            this.initialStringifySchema = this.getSchemaString(this.propertySchema);
            this.initialSchema = this.initialStringifySchema;
            this.workingSchema = this.initialStringifySchema;
            this.validateSchema(this.workingSchema);
        }
    }
    async checkFeatures() {
        this.isSchemaEditorEnabled = await BuilderFeatures.schemaEditorEnabled();
    }
    onSaveAction() {
        if (!this.onSave) {
            return console.warn('onSave callback is not provided.');
        }
        this.action.$inputSchema = this.workingSchema ? JSON.parse(this.workingSchema) : {};
        this.onSave({ $action: this.action });
    }
    getSchemaString($inputSchema) {
        try {
            const schema = this.stringifySchema($inputSchema);
            return schema === '{}' ? this.stringifySchema(getDefaultActionSchema()) : schema;
        }
        catch {
            return this.stringifySchema(getDefaultActionSchema());
        }
    }
    stringifySchema(schema) {
        return JSON.stringify(schema, null, 4);
    }
};
//#endregion
EditActionSchemaModalComponent.$inject = ['$timeout'];
EditActionSchemaModalComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: template,
        bindings: {
            action: '<',
            onClose: '&',
            onSave: '&',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof angular !== "undefined" && angular.ITimeoutService) === "function" ? _a : Object])
], EditActionSchemaModalComponent);
export { EditActionSchemaModalComponent };
